module.exports = __webpack_public_path__ + "static/media/palette.0ce31302.svg";